import { observer } from "mobx-react";
import React from "react";
import privacy from "../../localization/sources/nb/privacy";
import { getRedirectProps } from "../../url/redirect";
import { useLocStore } from "../../localization";
import { LocContext } from "../../localization/LocContext";
import styled from "styled-components";
import { concat } from "lodash";
import { concatClassnames } from "../../utils/util";

export interface Consent5000Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  noBorder?: boolean;
}

export const Consent5000 = observer((props: Consent5000Props) => {
  const { className, noBorder } = props;
  const L_PRIVACY = useLocStore(LocContext.PRIVACY);
  const L = useLocStore(LocContext.GENERAL);

  const linkToPrivacyStatement = (
    <a
      {...getRedirectProps("privacystatement", {
        mergeQs: {},
        target: "_blank",
      })}
    >
      {L.id("1dbee8f73676").loc("Personvernerklæring")}
    </a>
  );

  return (
    <StyledConsent5000 {...props}>
      <div
        className={concatClassnames([
          "consent-5000",
          className,
          noBorder ? "no-border" : "",
        ])}
      >
        {L_PRIVACY.id("CONSENT_5000").loc(privacy.CONSENT_5000)}
        {"\n\n"}
        {L.id("83558e5d01b9").split(
          "For mer informasjon om hvordan vi behandler dine opplysninger og rettigheter, se her: {0}.",
          [linkToPrivacyStatement]
        )}
      </div>
    </StyledConsent5000>
  );
});

const StyledConsent5000 = styled.div`
  .consent-5000 {
    border: 1px solid var(--primary-color);
    border-radius: 5px;
    padding: 1rem;
    white-space: pre-wrap;
    font-size: 0.9rem;
    max-height: 200px;
    overflow: auto;
    margin: 1rem 0;
  }

  .no-border {
    border: none;
    padding: 0;
    margin: 0;
  }
`;
